export const CATEGORY_MENU_ROOT_PATH = 'Custom Uploads';
